// h5调用App方法保存图片
export const saveExamResultImage = (base64Url) => {
  if (/android/i.test(navigator.userAgent)) {
    console.log("android --- saveExamResultImage");
    window.ZGWebBridgeManager.saveExamResultImage(base64Url);
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log("ios --- saveExamResultImage");
    window.webkit &&
    window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: "saveExamResultImage",
      params: {base64Url},
    });
  }
};
// 前往人脸验证
export const goFaceCompare = () => {
  if (/android/i.test(navigator.userAgent)) {
    console.log("android --- goFaceCompare");
    window.ZGWebBridgeManager.goFaceCompare();
  } else if (/ios|iphone|ipod|pad/i.test(navigator.userAgent)) {
    console.log("ios --- goFaceCompare");
    window.webkit &&
    window.webkit.messageHandlers.ZGEventHandler.postMessage({
      methodName: "goFaceCompare",
    });
  }
};
